import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ReportType } from "@bpm/models";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class ReportTypeService {
  //EndPoint para controlador de este objeto en backend
  private reportTypeApiURL = `${environment.bpmApiUrl}/api/report-types`;

  constructor(private _http: HttpClient) {}

  /**
   * Obtiene un listado de tipos de reporte activos (para combos)
   * @returns Devuelve un listado de tipos de reporte activos
   */
  getAllActive() {
    return this._http.get<ReportType[]>(`${this.reportTypeApiURL}`).pipe(
      map((response: any) => response as ReportType[]),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  /**
   * Obtiene todos los tipos de reporte
   * @returns Devuelve un listado completo de tipos de reporte
   */
  getAll() {
    return this._http.get<ReportType[]>(`${this.reportTypeApiURL}/all`).pipe(
      map((response: any) => response as ReportType[]),
      catchError((e) => {
        return throwError(e);
      })
    );
  }

  /**
   * Obtiene un tipo de reporte por medio de su id
   * @param {number} reportTypeId Indica el id del tipo de reporte
   * @returns Devuelve un tipo de reporte
   */
  getById(reportTypeId: number) {
    return this._http
      .get<ReportType>(`${this.reportTypeApiURL}/${reportTypeId}`)
      .pipe(
        map((response: any) => response as ReportType),
        catchError((e) => {
          return throwError(e);
        })
      );
  }
}
